import {
  createGlobalStyle
} from 'styled-components'

export default createGlobalStyle`
  /* Home
  ============================================================ */
  .home {
    .XXXXX {
      /* Style */
    }
  }
`
